import { render, staticRenderFns } from "./Realizacao.vue?vue&type=template&id=9d44e714&"
import script from "./Realizacao.vue?vue&type=script&lang=js&"
export * from "./Realizacao.vue?vue&type=script&lang=js&"
import style0 from "./Realizacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports